/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AddTagToTaggableRequest} from "../model/add-tag-to-taggable-request";
import {AddTagToTaggableResponse} from "../model/add-tag-to-taggable-response";
import {CountTagResponse} from "../model/count-tag-response";
import {CreateTagRequest} from "../model/create-tag-request";
import {RemoveTagFromTaggableRequest} from "../model/remove-tag-from-taggable-request";
import {RemoveTagFromTaggableResponse} from "../model/remove-tag-from-taggable-response";
import {Tag} from "../model/tag";
import {TagType} from "../model/tag-type";
/**
 * Controller for handling tagging related API requests.
 */ 

@Injectable({
    providedIn: "root",
})
export class SimTaggingService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
/**
 * Adds a tag to a ITaggable object if it does not already exist.
 */ 

    public addTagToTaggable(addTagToTaggableRequest: AddTagToTaggableRequest) {
        return super.post<AddTagToTaggableResponse>(`/api/Tagging/AddTagToTaggable`, addTagToTaggableRequest);
    }
/**
 * Test Endpoint to count tags used of a specific TagType.
 */ 

    public countTagsUsedOfTagType(tagType: TagType, startDate: Date | string, endDate: Date | string) {
        return super.get<CountTagResponse[]>(`/api/Tagging/CountTagsUsedOfTagType`, {tagType: tagType, startDate: startDate, endDate: endDate});
    }
/**
 * Creates a tag if not exists.
 */ 

    public createTag(createTagRequest: CreateTagRequest) {
        return super.post<Tag>(`/api/Tagging/CreateTag`, createTagRequest);
    }
/**
 * Retrieves a list of all Tag of a specific TagType.
 */ 

    public getAllTagsOfTagType(tagType: TagType) {
        return super.get<Tag[]>(`/api/Tagging/GetAllTagsOfTagType`, {tagType: tagType});
    }
/**
 * Retrieves a list of Tag by their IDs.
 */ 

    public getTagsByIds(tagIds: string[]) {
        return super.post<Tag[]>(`/api/Tagging/GetTagsByIds`, tagIds);
    }
/**
 * Removes a tag from a ITaggable object.
 */ 

    public removeTagFromTaggable(removeTagFromTaggableRequest: RemoveTagFromTaggableRequest) {
        return super.post<RemoveTagFromTaggableResponse>(`/api/Tagging/RemoveTagFromTaggable`, removeTagFromTaggableRequest);
    }
}